<template>
  <section id="reviews" class="section reviews-section">
    <div class="section-heading" v-reveal>
      <p class="section-kicker">Erfahrungen</p>
      <h2>Was Nutzer über GuildGuardian sagen.</h2>
    </div>
    <div class="reviews-list">
      <article
        v-for="(review, index) in reviews"
        :key="review.name"
        class="review-card"
        v-reveal
        :style="{ '--delay': `${index * 90}ms` }"
      >
        <img :src="reviewAvatars[review.avatar]" :alt="review.name" />
        <div>
          <h3>{{ review.name }}</h3>
          <p>{{ review.copy }}</p>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import damagingAngvelsAvatar from '../assets/review-damagingangvels.png'
import knallerAvatar from '../assets/review-knaller.jpg'
import marcelAvatar from '../assets/review-marcel.png'

export default {
  name: 'ReviewsSection',
  props: {
    reviews: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      reviewAvatars: {
        damagingAngvels: damagingAngvelsAvatar,
        knaller: knallerAvatar,
        marcel: marcelAvatar
      }
    }
  }
}
</script>
